import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	labelXDim1: {
		'id': 'dimension.labelXDim1',
		'defaultMessage': 'Answers',
	},
	labelYDim1: {
		'id': 'dimension.labelYDim1',
		'defaultMessage': 'Width',
	},
	labelXDim2: {
		'id': 'dimension.labelXDim2',
		'defaultMessage': 'Answers',
	},
	labelYDim2: {
		'id': 'dimension.labelYDim2',
		'defaultMessage': 'Height',
	},
	labelXDim3: {
		'id': 'dimension.labelXDim3',
		'defaultMessage': 'Answers',
	},
	labelYDim3: {
		'id': 'dimension.labelYDim3',
		'defaultMessage': 'Length',
	},
});


// WEBPACK FOOTER //
// ./src/components/ResultDimensions/messages.js